import { Box, BoxProps } from "@chakra-ui/react";
import { PropsWithChildren } from "react";

export function BaseStatCard(props: PropsWithChildren<BoxProps>) {
  return <Box bg={"gray.700"} p="6" rounded="lg" shadow="md" {...props} />;
}
